import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../../App/Services/AppService';
import AuthorisableUpdateRequestsByStatusVM from '../Components/AuthorisableUpdateRequestsByStatusVM';
import { TextConstants } from '../../../../Common/TextConstants';

export default class AuthorisableTransactionsVM extends Views.ViewModelBase {
    public pendingStatusVM: AuthorisableUpdateRequestsByStatusVM = new AuthorisableUpdateRequestsByStatusVM();
    public declinedStatusVM: AuthorisableUpdateRequestsByStatusVM = new AuthorisableUpdateRequestsByStatusVM();
    public processedStatusVM: AuthorisableUpdateRequestsByStatusVM = new AuthorisableUpdateRequestsByStatusVM();

    public status: string = "";
    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {

        super(taskRunner);
        this.makeObservable();
    }

    public async initialise() {        
        this.pendingStatusVM.load(TextConstants.GeneralText.Pending);
        this.pendingStatusVM.authorisableUpdateRequestPageManager.refreshData();

        this.declinedStatusVM.load(TextConstants.GeneralText.Declined);
        this.declinedStatusVM.authorisableUpdateRequestPageManager.refreshData();        

        this.processedStatusVM.load(TextConstants.GeneralText.Processed);
        this.processedStatusVM.authorisableUpdateRequestPageManager.refreshData();
    }
}